import storage from "./storage";

export default function($app) {
	const self = this;

	const $ui = $app.require('ui');
	const $playerNotification = $app.require('playerNotification');
	const $locale = $app.require('locale');

	self.title = ko.observable($locale.get('episodeFavorite.title'));
	self.position = $app.event().moduleEpisode.position;
	self.name = 'episodeFavorite';
	self.isEnabled = ko.computed(() => {
		return $app.event().moduleEpisode.episodeFavorite()
			&& $app.event().episode().length > 0
			&& $app.event().stream().length >= 1
			&& $app.event().moduleEpisode.position() !== 'hide'
		;
	});

	const selected = (function() {
		const selected = ko.observableArray();
		const episodeFavoriteKey = 'episodeFavorite/' + $app.event().eventKey();

		if (storage.get(episodeFavoriteKey)) {
			try {
				selected(storage.get(episodeFavoriteKey).split(',').map(id => parseInt(id)));
			} catch (e) {
				console.error('Cant parse episodeFavorite cookie');
			}
		}

		selected.subscribe(selected => {
			storage.set(episodeFavoriteKey, selected.join(','), storage.DAY * 365);
		});

		return selected;
	})();

	self.episode = ko.computed(() => $app.event().episode()
			.filter(episode => episode.isFavorite())
	);

	$app.on('start', () => {
		if(self.isEnabled()) {
			self.uiTab = new $ui.Tab(self);
		}
		$app.log('Начало проверки избранного');
		$app.event().episode().forEach(episode => {
			episode.isFavorite(selected().indexOf(episode.id()) >= 0);
			episode.isFavorite.subscribe(function(isFavorite) {
				isFavorite ? selected.push(episode.id()) : selected.remove(episode.id());
			});

			episode.type.subscribe(type => {
				if('live' === type && episode.isFavorite()) {
					const notification = $playerNotification.showNotification($locale.get('episodeFavorite.start.title'), episode.name(), 0);
					notification.onClick($app.setEpisode(episode));
				}
			})
		});
		$app.log('Проверка избранного окончена');
	});
};
